import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmlAutocompleteControlModule } from './cml-autocomplete-control/cml-autocomplete-control.module';
import { ValidationService } from './validation.service';
import { FormGroupManager } from './form-factory.service';
import { CreatJsonService } from './create-json.service';
import { CmlDropDownModule } from './cml-dropbox/cml-dropdown.module';



@NgModule({
  providers: [
    ValidationService,
    FormGroupManager,
    CreatJsonService
  ],
  declarations: [],
  imports: [
    CommonModule,
    CmlAutocompleteControlModule,
    CmlDropDownModule
  ],
  exports: [
    CmlAutocompleteControlModule,
    CmlDropDownModule
    ]
})
export class CmlFormsModule { }
